var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_29_107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_29_107",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_29_107",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_29_107",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD7ElEQVR4nO2dS0tVURTHf6ClUdSwzKDC+gI9RhVFWOEgskEFPaD3xEArTJs1yxyF4Nfo5aDQD1CEYdmkSTXpnY8adQVzxYFVxMXHLffZZ51z1w/+IJd7Ze8/m733WmftfcBxHMdxHMdxHMepmBpgO3AO6AXuAaPAa2ACmFJN6Gej+p1b+ptt+j+cWVgHdAADwHdAFqlvwAOgHWikylkGnAKGgJ8BzJ1L08AgcBKop4pYoSPtfYrmzqUvwA1gFQVmCdAJjGdgcLmSNlzVNhWKXcBLAwaX6xXQTAFI5sR+YMaAqXMpaVsfUEdO2QA8MWCkVKhnwCZyRnOgbZpEVrIt3EtOOAz8MGCa/KeSYOgYxrmY8p5YIinpwwWM0qrBQdYmSUCzj2KMZF4rGTBHUphG9mOEzTld+OQfFsimrE2u022RFFzDWe+z+w2YIJGUBDWZhdWWIz4JrKSvu2ObXAu8MNB5iayXsRNRnQY6LRnpcsx88piBDktGGlMPUqfLQGclYyW57NQfP30yEkh0AWtUXZEDpg9pPxY7ZcBkUWPLaYls9ok0jR4yYLLoKJ6NAxEzhw/TMrnRUNJozTztjGX2z7RKGToMGCyq7gXaGmsauZSG0QMGDBZVSc3M2uy7oU1OSqwmDRgsZTuPgwu0O+1pZDJ0+dl2A8aK0ZG9NaTR5w2YKkZH9pmQRvcaMFSMmn0zpNH3DZgpRs2+E9LovKRESxnM2SMhjX4bcNR1Ag1kS0iz34RsWKi06DXs0B2oT19DNmoqUKMasMPqgNOVOaPXYoe1Fo0eSzG9mRXXLU4dIRfDLgMj2+xi6Ns74mzvPGAhTsDiIThxQvBzgeYzKWBS6XRIoz1NypxGbwlptCf+iZP4R89WixGVDCT8gy+Ev2k3YLBUGPjEejjblobRSZDh5Qb8MXl6gbKHRTFoYDRL0Qto0KsYxGhdR0vkkrDjaRc5fjSyd+7WtGuD/h3T5Pcx7v6o5iJ0UV0hAss1NShVqrFYhehoIbZUqdqJfFjouYFOS9EPCyXs9ONv8egzMMokkm6TIXV6fFcKrqfAUjKmSQ+mS0E1CWzECHtyfuuMzBMY7cMYhwwlnSTQGZUjGOVCQa76mdaacNO05nwaKVm84me+q3++5XTh20POWA88NmCeVKhhC1f6LGaf3Wc8gpzRYCTzfXKocP2FAVPLlbRpBwWjVi8VsZBi/apZuKRNhWW5dvJdBgZ/1ou6V1JF1OtVDI9SDnSm9UHq8Wq7en42GvQA+119G8VizZ3Q/9WWZklA3qnRerazQI9WA43oq0DG/3o9yLh+NqLf6dFTrMlv/fUgjuM4juM4juM4VMgvsFJQNF1us8cAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardButton);
export default __webpack_public_path__ + "static/media/ForwardButton.91330496c3364b23b236524518330d5c.svg";
export { ForwardRef as ReactComponent };